import type {
  MembershipDurationEnum,
  MembershipType,
  UserType,
  VisualRefType,
  VisualTypeEnum
} from "@shared/graphql.types";

import type { WithTypeName } from "./types";

export const MEMBER_HOME_PAGE = "/";
export const DEFAULT_HOME_PAGE = "/";

export const NoAvatar: VisualRefType = {
  id: "no-avatar",
  url: "/none.jpg",
  name: "none",
  type: "image" as VisualTypeEnum,
  altTag: "none",
  usage: "full"
};

export const NoMembership: WithTypeName<MembershipType> = {
  id: "none:none",
  value: "none",
  duration: "none" as MembershipDurationEnum,
  name: "Non-Member",
  description:
    "You will buy products at typical price and miss out on all the savings",
  visual: NoAvatar,
  giftVisual: null,
  segment: "",
  price: 0,
  period: 0,
  frequency: 1,
  initEntitlement: 0,
  monthlyAllowance: 0,
  __typename: "MembershipType"
};

export const guestUser: WithTypeName<UserType> = {
  id: "initial",
  name: "guest",
  email: "guest@bp.com",
  membership: NoMembership,
  avatar: NoAvatar,
  spentSoFar: 0,
  carriedForward: 0,
  basketId: "",
  basketVersion: -1,
  basket: [],
  wishlistId: "",
  wishlistVersion: -1,
  wishlist: [],
  discounts: [],
  orderDraft: null,
  hints: [],
  reviews: [],
  dateOfBirth: null,
  MembershipEndDate: null,
  MembershipStartDate: null,
  registrationDateTime: null,
  pricing: null,
  includedDiscounts: [],
  rejectedDiscounts: [],
  TotalOrders: 0,
  LifetimeValueOrders: 0,
  LifetimeSubscriptionSaving: 0,
  deliveryType: "standard",
  isFreeTrialAllowed: true,
  __typename: "UserType"
};
